<template>
    <div class="container">
        <div>
            <div v-if="!uploadBegan">
                <br>
                <p class="title is-size-4">Tips for an effective loan request</p>
                <img src="../assets/fun.png" class="img">
                <p class="title is-size-6">Have fun!</p>
                <p class="subtitle is-size-6">Be unique, be creative. It's up to you what your gimmick is.</p>
                <img src="../assets/time.png" class="img">
                <p class="title is-size-6">Keep it short!</p>
                <p class="subtitle is-size-6">Be straight to the point. The shorter your video, the better.</p>
                <p class="is-size-7">Please note that videos can't be longer than one minute — anything beyond 60 seconds will be cut off.</p>
                <br>
            </div>
            <b-field v-if="!uploadBegan" class="file">
                <b-upload v-model="file" accept="video/*">
                    <a class="button">
                        <span>Select File or Record Video</span>
                    </a>
                </b-upload>
                <span class="file-name" v-if="file">
                    ✅ {{ file.name }}
                </span>
            </b-field>
            <br>
            <b-progress v-if="uploadBegan" :value="uploadPercentage" show-value format="percent"></b-progress>
            <b-button expanded type="is-primary" v-if="file && !uploadBegan" @click="submitFile">Upload Video 🚀</b-button>
        </div>
    </div>
</template>

<script>
    import BProgress from "buefy/src/components/progress/Progress";
    import BButton from "buefy/src/components/button/Button";
    export default {
        name: "upload-video",
        components: {BButton, BProgress},
        data() {
            return {
                file: null,
                uploadPercentage: 0,
                uploadBegan: false
            }
        },
        props: ['video_tmp'],
        methods: {
            submitFile(){
                const vm = this;
                vm.uploadBegan = true;
                let formData = new FormData();
                let extension = vm.file.name.split('.').pop(); //outputs extension without dot eg "docx" "mp4"
                let uuidString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                let uuidFileName = uuidString + "." + extension;
                formData.append('file', vm.file, uuidFileName);
                formData.append('expires', '1h');
                formData.append('no_index', 'true');
                vm.axios.post( 'https://api.anonymousfiles.io/',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        onUploadProgress: function( progressEvent ) {
                            vm.uploadPercentage = parseInt(Math.round( ( progressEvent.loaded / progressEvent.total ) * 100));
                        }.bind(this)
                    }
                ).then(function(res){
                    let data = res.data;
                    console.log(data);
                    let dlUrl = 'https://anonymousfiles.io/f/' + uuidFileName;
                    vm.$emit('update:video_tmp', dlUrl);
                })
                .catch(function(){
                    alert("Sorry, upload failed. Please try again");
                    vm.uploadPercentage = 0;
                    vm.uploadBegan = false;
                });
            }
        }
    }
</script>

<style scoped>
.img {
    height: 120px;
    margin: 12px 0px;
}
</style>